import { render, staticRenderFns } from "./MyCommercialAccountsTableV2.vue?vue&type=template&id=650fbcf2&scoped=true&"
import script from "./MyCommercialAccountsTableV2.vue?vue&type=script&lang=js&"
export * from "./MyCommercialAccountsTableV2.vue?vue&type=script&lang=js&"
import style0 from "./MyCommercialAccountsTableV2.vue?vue&type=style&index=0&id=650fbcf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650fbcf2",
  null
  
)

export default component.exports